import './QuickLink.css';

export default function QuickLink({ data }) {
    const { label, icon, onClick  } = data;
    
    return (
        <div className="quick-link" onClick={onClick}>
            <div className="quick-link-icon">
                {icon}
            </div>
            <div className="quick-link-label">
                {label}
            </div>
        </div>
    );
}